// HomePageIcons.js
import React from 'react';
import { FaInstagram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';  // 'X' (formerly Twitter)
import { SiBluesky } from 'react-icons/si';  // Bluesky icon
import styles from './HomePageIcons.module.css';

const HomePageIcons = () => {
  return (
    <div className={styles.iconsContainer}>
      <a href="https://bsky.app/profile/linkist.bsky.social" 
         target="_blank" 
         rel="noopener noreferrer"
         aria-label="Linkist on Bluesky">
        <SiBluesky className={`${styles.icon} ${styles.bluesky}`} />
      </a>
      <a href="https://twitter.com/linkist_se" 
         target="_blank" 
         rel="noopener noreferrer"
         aria-label="Linkist on Twitter">
        <FaXTwitter className={`${styles.icon} ${styles.twitter}`} />
      </a>
      <a href="https://instagram.com/linkist.se" 
         target="_blank" 
         rel="noopener noreferrer"
         aria-label="Linkist on Instagram">
        <FaInstagram className={`${styles.icon} ${styles.instagram}`} />
      </a>
    </div>
  );
};

export default HomePageIcons;